var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76 19.403h18.48c1.107 0 1.76-.558 1.76-1.377 0-1.138-1.178-2.163-2.192-3.175-.77-.786-.98-2.401-1.06-3.71-.094-4.37-1.272-7.386-4.384-8.478C13.932 1.183 12.72 0 11.006 0 9.28 0 8.079 1.183 7.636 2.663c-3.1 1.092-4.29 4.108-4.372 8.478-.093 1.309-.291 2.924-1.072 3.71l-.766.763C.67 16.383 0 17.172 0 18.026c0 .819.665 1.377 1.76 1.377zm5.69 1.547h7.112C14.41 22.612 12.976 24 11.006 24c-1.982 0-3.416-1.388-3.556-3.05z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconNotification.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };